import { Typography, useTheme } from "@mui/material";
import { FC } from "react";
import { useLocalization } from "../../../hooks/useLocalization";

interface ErrorDisplayProps {
  error: Error | null;
  title?: string;
  showErrorMessage?: boolean;
  bottom?: number;
  left?: number;
}

export const ErrorDisplay: FC<ErrorDisplayProps> = ({
  error,
  title,
  showErrorMessage = false,
  bottom,
  left,
}) => {
  const theme = useTheme();
  const { t } = useLocalization();
  const defaultTitle = title ?? t("users.errorDisplay.defaultTitle");

  if (!error) {
    return null;
  }

  return (
    <Typography
      component="pre"
      sx={{
        color: theme.colors.red,
        fontSize: 11,
        mt: 1,
        mb: 1,
        p: 1,
        borderRadius: 1,
        bottom,
        left,
        whiteSpace: "pre-wrap",
        overflow: "auto",
        maxHeight: "200px",
        position: "absolute",
      }}
    >
      {defaultTitle} {showErrorMessage && ` ${JSON.stringify(error.message)}`}
    </Typography>
  );
};
